/**
 * values for setting the 'days' in mult opt in field
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';
import _ from 'lodash';
const DAYS = {
  MONDAY:    'monday',
  TUESDAY:   'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY:  'thursday',
  FRIDAY:    'friday',
  SATURDAY:  'saturday',
  SUNDAY:    'sunday',
};

const DAYS_LIST_LONG = [
  { text: locale('Monday'), value: DAYS.MONDAY },
  { text: locale('Tuesday'), value: DAYS.TUESDAY },
  { text: locale('Wednesday'), value: DAYS.WEDNESDAY },
  { text: locale('Thursday'), value: DAYS.THURSDAY },
  { text: locale('Friday'), value: DAYS.FRIDAY },
  { text: locale('Saturday'), value: DAYS.SATURDAY },
  { text: locale('Sunday'), value: DAYS.SUNDAY },
];

const DAYS_LIST_SHORT = [
  { text: locale('Mon'), value: DAYS.MONDAY },
  { text: locale('Tue'), value: DAYS.TUESDAY },
  { text: locale('Wed'), value: DAYS.WEDNESDAY },
  { text: locale('Thu'), value: DAYS.THURSDAY },
  { text: locale('Fri'), value: DAYS.FRIDAY },
  { text: locale('Sat'), value: DAYS.SATURDAY },
  { text: locale('Sun'), value: DAYS.SUNDAY },
];

//for easier work with labels, this builds out an object
const DAY_LABELS = _.reduce(
  DAYS_LIST_SHORT,
  function(ret, day) {
    ret[day.value] = day.text;
    return ret;
  },
  {}
);

const DAYS_ALL = _.values(DAYS, 'value');
const DAYS_ALL_STR = DAYS_ALL.join(','); //we are going to use as default for each option of a multi opt in field.

//to be used for sorting the toggled days in a week
const DAYS_SORT = {
  [DAYS.MONDAY]:    1,
  [DAYS.TUESDAY]:   2,
  [DAYS.WEDNESDAY]: 3,
  [DAYS.THURSDAY]:  4,
  [DAYS.FRIDAY]:    5,
  [DAYS.SATURDAY]:  6,
  [DAYS.SUNDAY]:    7,
};

/**
 * function will sort an array of days like ['thursday', 'sunday', 'friday', 'monday'] into the correct week order: ['monday', 'thursday', 'friday', 'sunday']
 */
const sortDayArray = daysArray => {
  return daysArray.sort((a, b) => DAYS_SORT[a] - DAYS_SORT[b]);
};

/**
 * on a comma separated list of days, it will add or remove the given day
 * @param daysShown - comma separated list of days string
 * @param dayToToggle - the day that has to be added/removed into the list
 * @returns string - comma separated list of days, properly ordered
 */
const toggleDays = (daysShown, dayToToggle) => {
  const daysShownArr = daysShown && daysShown.length > 0 ? daysShown.split(',') : [], //splitting an empty string would result in an array with an empty value: "".split(',') -> [""]
    dayPos = daysShownArr.indexOf(dayToToggle);
  if (dayPos > -1) {
    daysShownArr.splice(dayPos, 1); //needs to be removed
  } else {
    daysShownArr.push(dayToToggle); //needs to be added
    sortDayArray(daysShownArr); //make sure days are in the correct order
  }
  return daysShownArr.join(',');
};

/**
 * returns true/false if the day is toggled
 * @param daysShown - comma separated list of days that are toggled
 * @param day - a given day, to be checked if it's toggled
 * @returns {boolean}
 */
const dayIsToggled = (daysShown, day) => {
  return daysShown ? daysShown.split(',').indexOf(day) > -1 : false;
};

/**
 * in case of a multi opt in field, this will build out a list of days when a given opt-in would show up
 */
const getDayLabels = daysShown => {
  const dayLabels = _.map(daysShown.split(','), (day, i) => DAY_LABELS[day]);
  return dayLabels.join(', ');
};

export {
  DAYS,
  DAYS_LIST_LONG,
  DAYS_LIST_SHORT,
  DAYS_ALL,
  DAYS_ALL_STR,
  DAY_LABELS,
  getDayLabels,
  toggleDays,
  dayIsToggled,
};

export default DAYS;
